import React from 'react';

import { View } from '@uncinc/react-drupal-core';

import type { RelatedContentProps } from '../types';

interface RelatedContentRelatedArticlesProps extends Pick<RelatedContentProps, 'args' | 'filters'> {
  display: string;
  viewClassName?: string;
  itemClassName?: string;
}

const RelatedContentRelatedArticles: React.FC<RelatedContentRelatedArticlesProps> = (props) => {
  const {
    display,
    args,
    filters,
    ...restProps
  } = props;

  return (
    <View
      {...restProps}
      key={`related_articles:${args.join(':')}`}
      id="article"
      display={display}
      args={args}
      filters={filters}
      resetStateOnUnmount
    />
  );
};

export default RelatedContentRelatedArticles;
